import { ReactComponent as ExclamationIcon } from 'icons/exclamation-red.svg';

function UnsupportedBrowserFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="mx-auto w-full max-w-md rounded-md bg-red-50 p-4">
        <div className="flex">
          <div className="shrink-0">
            <ExclamationIcon aria-hidden="true" className="text-red-400" />
          </div>
          <div className="ml-3">
            <h3 className="text-base font-semibold text-red-800">
              Your browser does not support some features required by this
              application.
            </h3>
            <p className="text-sm text-red-700">
              Please update your browser or use a different one.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export { UnsupportedBrowserFallback };
